//FNPVVEP-24 - FIX - INICIO
import React from 'react';
import * as FaIcons from 'react-icons/fa';

export default function IconRenderer ({ iconName, size }){
    const IconComponent = FaIcons[iconName] || null;
    return IconComponent ? <IconComponent size={size} /> : <p>Icon not found</p>;
};
//FNPVVEP-24 - FIX - FIM